$(function() {
    initDatagrid();
})

window.initDatagrid = function (el) {
    const table = $('#' + ( el ? el + 'DataTable' : 'dataTable' ) + ' table')
    const dataTableWrapper = $('#' + ( el ? el + 'DataTable' : 'dataTable' ) + 'Wrapper').empty().fadeIn(1000);

    if (!table.length || !dataTableWrapper.length) return

    const rows = Array.from(table.find('tbody tr')).map(row =>
        Array.from($(row).find('td')).map(cell => cell)
    )

    const initialFilter = table.data('initial-filter')

    let initialRows = initialFilter ? applyInitialFilter(initialFilter, rows) : rows

    let initialHeaders = $.map(table.find('thead th'), function(header, index) {
        const parser = new DOMParser()

        let sorting = false

        switch($(header).data('sorting')) {
            case "initial":
                sorting = {
                    compare: (a, b) => {
                        let keyString1 = parser.parseFromString(a.props.content, 'text/html')
                        let key1 = keyString1.querySelector('div').getAttribute('data-sort-key')

                        let keyString2 = parser.parseFromString(b.props.content, 'text/html')
                        let key2 = keyString2.querySelector('div').getAttribute('data-sort-key')
                        
                        return key2 - key1
                    }
                }
                break
            case "number":
                sorting = {
                    compare: (a, b) => {
                        let number1 = Number(parser.parseFromString(a.props.content, 'text/html').body.textContent || '')
                        let number2 = Number(parser.parseFromString(b.props.content, 'text/html').body.textContent || '')

                        return number2 - number1
                    }
                }
                break
            case "text":
                sorting = {
                    compare: (a, b) => {
                        let text1 = parser.parseFromString(a.props.content, 'text/html').body.textContent || ''
                        let text2 = parser.parseFromString(b.props.content, 'text/html').body.textContent || ''
                        
                        return text1.localeCompare(text2)
                    }
                }
                break
            case "date":
                sorting = {
                    compare: (a, b) => {
                        let dateString1 = parser.parseFromString(a.props.content, 'text/html')
                        let date1 = dateString1.querySelector('div') ? dateString1.querySelector('div').getAttribute('data-sort-key') : '1970-01-01'

                        let dateString2 = parser.parseFromString(b.props.content, 'text/html')
                        let date2 = dateString2.querySelector('div') ? dateString2.querySelector('div').getAttribute('data-sort-key') : '1970-01-01'
                        
                        return date1.localeCompare(date2)
                    }
                }
                break
        }

        let width = '200px'

        switch ($(header).data('column-width')) {
            case 'huge':
                width = '300px'
                break;
            case 'large':
                width = '275px'
                break;
            case 'wide':
                width = '225px'
                break;
            case 'big':
                width = '190px'
                break;
            case 'small':
                width = '175px'
                break;
            case 'narrow':
                width = '125px'
                break;
            case 'tiny':
                width = '100px'
                break;
            case 'column':
                width = '85px'
                break;
            case 'reset':
                width = null
                break;
        }
        
        let id = $(header).data('id')

        return {
            id: id ?? ( index + 1 ),
            name: $(header).data('hide-label') !== undefined ? '' : header.textContent,
            sort: sorting,
            width: width,
            hidden: $(header).data('hide') !== undefined
        }
    })

    let headers = initialHeaders

    const hidePagination = table.data('hide-pagination') !== undefined
    const pageSize = table.data('pagination-limit') ?? 20
    const hideSearch = table.data('hide-search') !== undefined

    const showTableControls = initialRows.length > pageSize && !hidePagination

    const pagination = {
        limit: pageSize,
        buttonsCount: false,
        nextButton: showTableControls,
        prevButton: showTableControls
    }

    let datagrid = new gridjs.Grid({
        columns: headers,
        data: () => {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve(initialRows)
                    $('#dataTableQuickFilters').addClass('z-10').removeClass('opacity-50').find('button').prop('disabled', false)
                }, 1000);
            })
        },
        className: {
            table: table.attr('class')
        },
        pagination: showTableControls ? pagination : false,
        search: !hideSearch,
        language: {
            search: {
                placeholder: "Durchsuchen",
            },
            sort: {
                sortAsc: "Aufsteigend sortieren",
                sortDesc: "Absteigend sortieren"
            },
            pagination: {
                previous: "Zurück",
                next: "Weiter",
                showing: "Ergebnis",
                of:"von",
                to:"bis",
                results: () => null,
            },
            loading: "Laden",
            noRecordsFound: "Keine Ergebnisse",
            error: "Es kam leider zu einem Fehler - bitte lade die Seite nochmal"
        }
    })
    .render(dataTableWrapper.get(0))
    .on('rowClick', (...args) => {
        if ($(table).data('disable-row-click') !== undefined) return

        if (['BUTTON', 'A'].includes(args[0].target.tagName)) return

        const cells = args[1]._cells.map(cell => cell.data.props.content)

        let link = null

        for (const html of cells) {
            const doc = new DOMParser().parseFromString(html, 'text/html')

            link = doc.querySelector('a[data-rowclick]')
            if (link) break

            if (!link) {
                const fallbackLink = doc.querySelector('a')
                if (fallbackLink && !link) {
                    link = fallbackLink
                }
            }
        }

        if (link?.href) {
            if (link.target === '_blank') {
                window.open(link.href, '_blank')
            } else {
                window.location.href = link.href
            }
        }
    })
    /*
    .on('ready', () => {})
    */

    initCustomFilter(datagrid, rows, initialRows, headers, initialHeaders, pagination)   

    highlightRowBelated()
}

function applyInitialFilter(filter, rows) {
    switch (filter) {
        case 'songs':
            return rows.filter(row => row[2].textContent.includes('Archiviert') !== true)
        default:
            return rows
    }
}

function initCustomFilter(datagrid, rows, initialRows, headers, initialHeaders, pagination) {
    const dataTableQuickFilters = $('#dataTableQuickFilters').fadeIn(1000).css('display', 'flex');

    if ($('.toggleArchivedSongs').length) {
        $('.toggleArchivedSongs').on('click', function() {
            dataTableQuickFilters.removeClass('z-10').addClass('opacity-50').find('button').prop('disabled', true).not(this).removeClass('filter-button-active')
    
            datagrid.updateConfig({
                data: () => {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            resolve($(this).hasClass('filter-button-active') ? rows : rows.filter(row => row[2].textContent.includes('Archiviert') !== true))
                            dataTableQuickFilters.addClass('z-10').removeClass('opacity-50').find('button').prop('disabled', false)
                        }, 1000)
                    })
                }
            }).forceRender()
    
            $(this).toggleClass('filter-button-active')
        })    
    }
    
    if ($('.toggleRecentSongs').length) {
        $('.toggleRecentSongs').on('click', function() {
            dataTableQuickFilters.removeClass('z-10').addClass('opacity-50').find('button').prop('disabled', true).not(this).removeClass('filter-button-active')

            datagrid.updateConfig({
                data: () => {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            resolve($(this).hasClass('filter-button-active') ? rows.filter(row => row[2].textContent.includes('Aktuell')) : initialRows)
                            dataTableQuickFilters.addClass('z-10').removeClass('opacity-50').find('button').prop('disabled', false)
                        }, 1000)
                    })
                }
            }).forceRender()

            $(this).toggleClass('filter-button-active')
        })
    }
    
    if ($('.toggleMyPlanMinistryGroups').length) {
        $('.toggleMyPlanMinistryGroups').on('click', function() {
            dataTableQuickFilters.removeClass('z-10').addClass('opacity-50').find('button').prop('disabled', true).not(this).removeClass('filter-button-active')

            const userMinistries = $(this).data('groups').split(',')

            const headersMap = new Map(headers.map(item => [item.id, item]))

            const sortedHeaders = userMinistries.map(id => {
                const item = headersMap.get(id);
                return item ? { ...item, hidden: false } : null;
            }).filter(Boolean)
            const remainingHeader = headers
                .filter(item => !userMinistries.includes(item.id))
                .map(item => ({ ...item, hidden: true }))
            const reorderedHeaders = [...sortedHeaders, ...remainingHeader]

            const headerIndexMap = new Map(
                headers.map((header, index) => [header.id, index])
            )
            const reorderedRows = rows.map(row =>
                reorderedHeaders.map(header => row[headerIndexMap.get(header.id)])
            )

            datagrid.updateConfig({
                columns: $(this).hasClass('filter-button-active') ? initialHeaders : reorderedHeaders,
                data: () => {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            resolve($(this).hasClass('filter-button-active') ? reorderedRows : initialRows)
                            dataTableQuickFilters.addClass('z-10').removeClass('opacity-50').find('button').prop('disabled', false)
                            highlightRowBelated()
                        }, 1000)
                    })
                }
            }).forceRender()

            $(this).toggleClass('filter-button-active')
        })
    }

    if ($('.toggleMyPlanningMinistryGroups').length) {
        $('.toggleMyPlanningMinistryGroups').on('click', function() {
            dataTableQuickFilters.removeClass('z-10').addClass('opacity-50').find('button').prop('disabled', true).not(this).removeClass('filter-button-active')

            const userMinistries = $(this).data('groups').split(',')

            datagrid.updateConfig({
                data: () => {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            resolve($(this).hasClass('filter-button-active') ? rows.filter(row => userMinistries.some(ministry => row[1].textContent.includes(ministry))) : initialRows)
                            dataTableQuickFilters.addClass('z-10').removeClass('opacity-50').find('button').prop('disabled', false)
                        }, 1000)
                    })
                },
                pagination: $(this).hasClass('filter-button-active') ? pagination : false
            }).forceRender()

            $(this).toggleClass('filter-button-active')
        })
    }

    if ($('.toggleUsers').length) {
        $('.toggleUsers').on('click', function() {
            dataTableQuickFilters.removeClass('z-10').addClass('opacity-50').find('button').prop('disabled', true).not(this).removeClass('filter-button-active')

            const userTypes = $(this).data('types').split(',')

            datagrid.updateConfig({
                data: () => {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            resolve($(this).hasClass('filter-button-active') ? rows.filter(row => userTypes.some(ministry => row[0].textContent.includes(ministry))) : initialRows)
                            dataTableQuickFilters.addClass('z-10').removeClass('opacity-50').find('button').prop('disabled', false)
                        }, 1000)
                    })
                }
            }).forceRender()

            $(this).toggleClass('filter-button-active')
        })
    }

    if ($('.filterCategories').length) {
        $('.filterCategories').on('change', function() {
            dataTableQuickFilters.removeClass('z-10').addClass('opacity-50').find('select').prop('disabled', true).not(this).removeClass('filter-button-active')

            const selectedCategory = $(this).val()

            datagrid.updateConfig({
                data: () => {
                    return new Promise(resolve => {
                        setTimeout(() => {
                            resolve(selectedCategory ? rows.filter(row => row[0].textContent.includes(selectedCategory)) : initialRows)
                            dataTableQuickFilters.addClass('z-10').removeClass('opacity-50').find('select').prop('disabled', false)
                        }, 1000)
                    })
                }
            }).forceRender()
        })
    }
}

function highlightRowBelated() {
    return new Promise(resolve => {
        const apply = () => {
            const $rows = $('.gridjs tr')

            if (!$rows.length) return false

            $rows.addClass('group')

            const $el = $('.gridjs [data-next-sunday]')

            if (!$el.length) return false

            $el.closest('tr')
                .addClass('highlight-row')
                .attr('data-highlight', 'highlight')

            resolve($el)

            return true
        }

        if (apply()) return

        const observer = new MutationObserver(() => {
            if (apply()) observer.disconnect()
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    })
}